import { install as PrintDesignInstall } from './PrintDesign/index';
import OpenPrintInstall from '../components/OpenPrint';
import { openPrint } from '../components/OpenPrint';

export default {
	install(Vue){
		Vue.use(PrintDesignInstall);
        Vue.use(OpenPrintInstall);
	}
}